import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    allowedRoles
}) => {
    const { isAuthenticated, user, _hasHydrated } = useAuthStore();
    const location = useLocation();


    if (!_hasHydrated) {
        // Show a loading state while we rehydrate the auth state from storage
        return (
            <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center">
                <div className="w-10 h-10 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
            </div>
        );
    }

    if (!isAuthenticated) {
        // Redirect to login if not authenticated
        console.warn(`[ProtectedRoute] Not authenticated, redirecting to login from ${location.pathname}`);
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (allowedRoles && user && !allowedRoles.includes(user.role)) {
        // Redirect to unauthorized if role not allowed
        console.warn(`[ProtectedRoute] Role ${user.role} not allowed for ${location.pathname}, redirecting to root`);
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};
